module.exports = __webpack_public_path__ + "img/ava2.fa465587.jpg";